import ColumnHead from "../column-head"

const CLASSNAME_CHANGE_MODE = ".js-fctable-day"

function ChangeModePlugin($pool, $dataProxy, plugins, controller) {
  const columnHeads = new Map()
  const changeMode = controller.changeMode.bind(controller)

  return function run(eventName, { node, tableName, columnName, mode, newMode }) {
    if (eventName === "Table:connectContent") {
      const currentTable = new Map()
      columnHeads.set(node.dataset.tableName, currentTable)
      const heads = Array.from(node.querySelectorAll(CLASSNAME_CHANGE_MODE))

      $pool.push("Table:connectContent::finish", () => {
        heads.forEach((head) => {
          const columnHead = ColumnHead.construct(head)
          if (columnHead === null) return

          columnHead.setClickListener(changeMode)
          currentTable.set(columnHead.columnName, columnHead)
        })
      })
    }

    if (eventName !== "Table:changeMode") return

    $pool.push("Table:changeMode::mutate", () => {
      const columnHead = columnHeads.get(tableName).get(columnName)
      if (!columnHead) return
      const newColumnHead = columnHead.applyTransformations(mode, newMode)
      columnHead.mode = newMode

      if (newColumnHead) newColumnHead.setClickListener(changeMode)
    })
  }
}

export default ChangeModePlugin
